<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Suggestions</h4>
                            <!-- <p class="card-category">List of tasks</p> -->
                            <p></p>

                        </template>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'id'">Id</span>
                                        <span v-else-if="column === 'index'">#</span>
                                        <span v-else-if="column === 'botanical_name'">Botanical name</span>
                                        <span v-else-if="column === 'commn_name'">Common name</span>
                                        <span v-else-if="column === 'view'"></span>
                                        <span v-else-if="column === 'remove'"></span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data" class="table-row">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'created_at'">
                                                {{ item[column] | toEasyDate }}
                                            </span>
                                            <span v-else-if="column === 'view'">
                                                <button type="button" class="btn btn-success"
                                                        @click.prevent="() => view(item.id)">
                                                    <i class="fas fa-id-card"></i>
                                                    
                                                </button>
                                            </span>
                                            <span v-else-if="column === 'remove'">
                                                <button type="button" class="btn btn-danger"
                                                        @click.prevent="() => remove(item.id)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </span>
                                            <span v-else>{{item[column]}}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            Next
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Previous
                        </div>

                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
    const _ = require('lodash')
    const axios = require('axios')
    import LTable from 'src/components/UIComponents/Table.vue'
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    import moment from 'moment'

    export default {
        components: {
            LTable,
            Card
        },
        created: function () {
            this.get();

            document.title = `Suggestions`;
        },
        data() {
            return {
                columns: ['index', 'id', 'botanical_name', 'common_name', 'created_at', 'view','remove'],
                data: [],
                limit: 100,
                offset: 0,
                search: '',
            }
        },
        filters: {
            toEasyDate (value) {
                return moment(String(value)).format('DD.MM.YYYY, HH:mm')
            },
            toShortText (value) {
                return value.length > 50 ? value.substr(0, 50) + '...' : value.substr(0, 50)
            }
        },
        methods: {
            get: function () {
                let self = this;

                let token = localStorage.getItem('token');

                axios.get(
                    `${this.$hostname}/admin/suggestions`,
                    {
                        'params': {
                            limit: this.limit,
                            offset: this.offset,
                        },
                        'headers': {
                            'Authorization': token
                        }
                    })
                    .then(function (response) {
                        self.data = response.data.map((p, index) => {
                                p['index'] = index +1 + self.offset ;
                                return p;
                            });
                    })
                    .catch(function (error) {
                        console.log(error)
                    })

            },
            prev: function () {
                if (this.offset >= this.limit) {
                    this.offset -= this.limit;
                    this.get();
                }
            },
            next: function () {
                if (this.data.length === this.limit) {
                    this.offset += this.limit;
                    this.get();
                }
            },
            view: function (id) {
                let route = this.$router.resolve({path: `/suggestions/${id}`});
                window.open(route.href, '_blank');
            },
            remove: async function (id) {
                let token = localStorage.getItem('token');

                if(!confirm(`Are you sure?`)){
                   return false;
                }

                await axios.post(
                    `${this.$hostname}/admin/suggestions/remove`,
                    {id: id},
                    {
                        'headers': {
                            'Authorization': token
                        }
                    });

                await this.get();
            }
        }
    }
</script>
<style scoped>
    .b {
        font-weight: 800 !important;
    }
    .pagination-button {
        height: 30px;
        padding: 1px 16px;
        margin-left: 20px;
        color: #fff !important;
    }
    .pagination-button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .text-primary {
        cursor: pointer;
    }

    .wallpapers-preview {
        cursor: pointer;
        max-height: 200px;
    }

    .mt10 {
        margin-top: 10px;
    }

    .btn-fill {
        margin-top: 25px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }

    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }
    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .device1 {
        display: block;
        width: 92px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 30px;
    }
    .device2 {
        display: block;
        width: 112px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 20px;
    }
    .device3 {
        display: block;
        width: 150px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
    }
    .mt30 {
        margin-top: 30px;
    }
    .color-block {
        display: block;
        width: 50px;
        height: 50px;
    }
    .table-row {
        /* cursor: pointer; */
    }
    .string-input {
        height: 35px;
    }
    .preview-img {
        width: 100px;
        height: 100px;
        /* margin-bottom: 20px; */
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Suggestions/Suggestions.vue